<template>
  <div class="service">
    <div :loading="loading">
      <div class="serviceContent">
        <div class="contentHeader">
          <div class="headerThumb costThumb">
            <div class="thumbIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-6"
              >
                <path
                  d="M4.5 3.75a3 3 0 0 0-3 3v.75h21v-.75a3 3 0 0 0-3-3h-15Z"
                />
                <path
                  fill-rule="evenodd"
                  d="M22.5 9.75h-21v7.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-7.5Zm-18 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div class="thumbContent">
              <div class="contentTitle">
                <span>هزینه سفر:</span>
              </div>
              <div class="contentValue">
                <span>{{ formatPrice(service_data.amount) }}</span>
                <span>تومان</span>
              </div>
            </div>
          </div>
          <div class="headerThumb creditThumb">
            <div class="thumbIcon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                <path
                  d="M128 96C92.7 96 64 124.7 64 160L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 256C576 220.7 547.3 192 512 192L136 192C122.7 192 112 181.3 112 168C112 154.7 122.7 144 136 144L520 144C533.3 144 544 133.3 544 120C544 106.7 533.3 96 520 96L128 96zM480 320C497.7 320 512 334.3 512 352C512 369.7 497.7 384 480 384C462.3 384 448 369.7 448 352C448 334.3 462.3 320 480 320z"
                />
              </svg>
            </div>
            <div class="thumbContent">
              <div class="contentTitle">
                <span>اعتبار شما:</span>
              </div>
              <div class="contentValue">
                <span>{{ formatPrice(credit) }}</span>
                <span>تومان</span>
              </div>
            </div>
            <div class="thumbBtn">
              <div class="addCreditBtn" @click="creadit_pay()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="size-6"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="BtnShowPaymentCreate">
              <div class="classMotherOneShowPayment">
                <div class="OneShowPayment">
                  <VsxIcon iconName="Money" :size="20" color="#076177" type="linear" />
                  <p>
                    هزینه سفر:
                  </p>
                  <span>{{ formatPrice(service_data.amount) }}</span>
                  <span>تومان</span>
                </div>

                <div></div>
              </div>

              <div class="classMotherOneShowPayment">
                <div class="OneShowPayment">
                  <VsxIcon iconName="EmptyWallet" :size="20" color="#076177" type="linear" />
                  <p>
                    اعتبار شما:
                  </p>
                  <span>{{ formatPrice(credit) }}</span>
                  <span>تومان</span>
                </div>

                <div>
                  <VsxIcon @click="creadit_pay()" iconName="Add" :size="32" color="#5584FF" type="linear" />
                </div>
              </div>
            </div> -->

        <div class="PeymentMethods payemntMethodTitle">روش پرداخت</div>

        <div>
          <!--                <label>-->
          <!--                  <div v-if="UseCredit != 'credit'" class="TextChildIconShowToUserOne">-->
          <!--                    <p>کیف پول</p>-->
          <!--                    <vs-switch @change="credit_method('credit')" color="success" v-model="switch2">-->
          <!--                      <template v-if="UseCredit != 'credit'" v-slot:on>-->
          <!--                        <span>هستم</span>-->
          <!--                      </template>-->

          <!--                      <template v-if="UseCredit == 'credit'" v-slot:off>-->
          <!--                        <span>نیستم</span>-->
          <!--                      </template>-->
          <!--                    </vs-switch>-->
          <!--                  </div>-->
          <!--                </label>-->

          <!--                <label v-if="UseCredit == 'credit'">-->
          <!--                  <input type="checkbox"  disabled />-->
          <!--                  کیف پول-->
          <!--                </label>-->
        </div>

        <div class="paymentMethodsoptions">
          <div
            class="optionThumb walletThumb"
            :class="{ selected: UseCredit == 'credit' }"
            @click="credit_method('credit')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
              <path
                d="M128 96C92.7 96 64 124.7 64 160L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 256C576 220.7 547.3 192 512 192L136 192C122.7 192 112 181.3 112 168C112 154.7 122.7 144 136 144L520 144C533.3 144 544 133.3 544 120C544 106.7 533.3 96 520 96L128 96zM480 320C497.7 320 512 334.3 512 352C512 369.7 497.7 384 480 384C462.3 384 448 369.7 448 352C448 334.3 462.3 320 480 320z"
              />
            </svg>
            <span>کیف پول</span>
          </div>
          <div
            class="optionThumb"
            :class="{ selected: UseCredit == 'manual' }"
            @click="credit_method('manual')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="size-6"
            >
              <path d="M12 7.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z" />
              <path
                fill-rule="evenodd"
                d="M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 14.625v-9.75ZM8.25 9.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM18.75 9a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V9.75a.75.75 0 0 0-.75-.75h-.008ZM4.5 9.75A.75.75 0 0 1 5.25 9h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V9.75Z"
                clip-rule="evenodd"
              />
              <path
                d="M2.25 18a.75.75 0 0 0 0 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 0 0-.75-.75H2.25Z"
              />
            </svg>
            <span>نقدی</span>
          </div>
        </div>
        <!-- <div class="DivPaymentGetLabel">
                <div @click="credit_method('manual')" :style="UseCredit == 'manual' ? 'background: rgb(18, 135, 165) ; color: #fff' : 'background: #eee' " class="ChildDivPaymentGetLabel">
                  نقدی
                  <VsxIcon v-if="UseCredit != 'manual'" iconName="Money" :size="28" color="#333" type="linear" />
                  <VsxIcon v-if="UseCredit == 'manual'" iconName="Money" :size="28" color="#fff" type="linear" />
                </div>

                <div @click="credit_method('credit')" :style="UseCredit == 'credit' ? 'background: rgb(18, 135, 165); color: #fff' : 'background: #eee' " class="ChildDivPaymentGetLabel">
                  کیف پول
                  <VsxIcon v-if="UseCredit != 'credit'" iconName="EmptyWallet" :size="28" color="#333" type="linear" />
                  <VsxIcon v-if="UseCredit == 'credit'" iconName="EmptyWallet" :size="28" color="#fff" type="linear" />
                </div>
              </div> -->

        <div>
          <!--                <label>-->
          <!--                  <input type="checkbox" v-if="UseCredit != 'manual'" @change="credit_method('manual')" />-->
          <!--                  پرداخت نقدی-->
          <!--                </label>-->

          <!--                <label>-->
          <!--                  <input type="checkbox" v-if="UseCredit == 'manual'" disabled />-->
          <!--                  پرداخت نقدی-->
          <!--                </label>-->
        </div>
        <div class="destionationThumbWrapper">
          <div class="destionationThumb">
            <div class="thumbIcon circle"></div>
            <div class="thumbInfo">
              <div class="thumbTitle">مبدا:</div>
              <div class="thumbValue">
                <span>{{ service_data.address }}</span>
              </div>
            </div>
          </div>
          <div
            class="destionationThumb"
            :class="{ beforeLastmarker: service_data.second_destination == 0 }"
          >
            <div class="thumbIcon square"></div>
            <div class="thumbInfo">
              <div class="thumbTitle">مقصد:</div>
              <div class="thumbValue">
                <span>{{ service_data.destination }}</span>
              </div>
            </div>
          </div>
          <div
            v-if="service_data.second_destination != 0"
            class="destionationThumb Lastmarker"
          >
            <div class="thumbIcon square"></div>
            <div class="thumbInfo">
              <div class="thumbTitle">مقصد دوم:</div>
              <div class="thumbValue">
                <span>{{ service_data.second_destination }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="travelShareBtn" @click="this.$refs.issheet_share1.open()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
            <path
              d="M448 256C501 256 544 213 544 160C544 107 501 64 448 64C395 64 352 107 352 160C352 165.4 352.5 170.8 353.3 176L223.6 248.1C206.7 233.1 184.4 224 160 224C107 224 64 267 64 320C64 373 107 416 160 416C184.4 416 206.6 406.9 223.6 391.9L353.3 464C352.4 469.2 352 474.5 352 480C352 533 395 576 448 576C501 576 544 533 544 480C544 427 501 384 448 384C423.6 384 401.4 393.1 384.4 408.1L254.7 336C255.6 330.8 256 325.5 256 320C256 314.5 255.5 309.2 254.7 304L384.4 231.9C401.3 246.9 423.6 256 448 256z"
            />
          </svg>
          <span>سفر خود را به اشتراک بگذارید</span>
        </div>

        <!-- <div style=" margin-top: 10px"  class="ShowNewservice_data_1">
              <div class="AllShowDoddet">
                <div class="AllShowDoddetC">
                  <p>{{service_data.address}}</p>

                  <div class="AllShowDoddetC1">
                    <span>
                      :
                      مبدا
                    </span>

                    <VsxIcon iconName="Location" :size="25" color="#5584FF" type="linear" />
                  </div>
                </div>
                <div style="height: 10px !important;" class="ShowDoddet"></div>
                <div class="AllShowDoddetC">
                  <p>{{service_data.destination}}</p>

                  <div class="AllShowDoddetC1">
                    <span>
                      :
                      مقصد
                    </span>

                    <VsxIcon iconName="LocationTick" :size="25" color="#5584FF" type="linear" />
                  </div>
                </div>
                <div v-if="service_data.second_destination != 0" style="height: 10px !important;" class="ShowDoddet"></div>
                <div v-if="service_data.second_destination != 0" class="AllShowDoddetC">
                  <p>{{service_data.second_destination}}</p>

                  <div class="AllShowDoddetC1">
                    <span>
                      :
                      مقصد 2
                    </span>

                    <VsxIcon iconName="LocationAdd" :size="25" color="#5584FF" type="linear" />
                  </div>
                </div>
              </div>
            </div> -->
      </div>
    </div>

    <vue-bottom-sheet ref="issheet_share1" v-model="issheet_share">
      <v-sheet class="text-center py-2 px-2">
        <div style="margin-top: 0" class="PeymentMethods">
          اشتراک سفر از طریق
        </div>

        <div class="ShareDriverClass">
          <!--          <v-col cols="3"  class="d-flex justify-center">-->
          <ShareNetwork
            @open="issheet_share = false"
            network="WhatsApp"
            :url="taxi_c_set.company_site"
            :title="pro_name"
            :description="
              'من ' +
              pro_name +
              ' گرفتم و تاکسی این مشخصات رو دارد - ' +
              'نام راننده: ' +
              service_data.driver_name +
              ' - نام خودرو: ' +
              service_data.car_name +
              ' - رنگ خودرو: ' +
              service_data.car_color +
              ' - پلاک خودرو: ' +
              plaque_[0] +
              ' ' +
              plaque_[1] +
              ' ' +
              plaque_[2] +
              ' ' +
              plaque_[3] +
              ' ایران '
            "
          >
            <img style="width: 60px" src="@/assets/images/whatsapp.png" />
          </ShareNetwork>
          <!--          </v-col>-->

          <v-col cols="3" class="d-flex justify-center">
            <ShareNetwork
              @open="issheet_share = false"
              network="Telegram"
              :url="taxi_c_set.company_site"
              :title="pro_name"
              :description="
                'من ' +
                pro_name +
                ' گرفتم و تاکسی این مشخصات رو دارد - ' +
                'نام راننده: ' +
                service_data.driver_name +
                ' - نام خودرو: ' +
                service_data.car_name +
                ' - رنگ خودرو: ' +
                service_data.car_color +
                ' - پلاک خودرو: ' +
                plaque_[0] +
                ' ' +
                plaque_[1] +
                ' ' +
                plaque_[2] +
                ' ' +
                plaque_[3] +
                ' ایران '
              "
            >
              <img style="width: 100px" src="@/assets/images/Telegram.png" />
            </ShareNetwork>
          </v-col>

          <v-col cols="3" class="d-flex justify-center">
            <ShareNetwork
              @open="issheet_share = false"
              network="SMS"
              :url="taxi_c_set.company_site"
              :title="pro_name"
              :description="
                'من ' +
                pro_name +
                ' گرفتم و تاکسی این مشخصات رو دارد - ' +
                'نام راننده: ' +
                service_data.driver_name +
                ' - نام خودرو: ' +
                service_data.car_name +
                ' - رنگ خودرو: ' +
                service_data.car_color +
                ' - پلاک خودرو: ' +
                plaque_[0] +
                ' ' +
                plaque_[1] +
                ' ' +
                plaque_[2] +
                ' ' +
                plaque_[3] +
                ' ایران '
              "
            >
              <img style="width: 60px" src="@/assets/images/sms.png" />
            </ShareNetwork>
          </v-col>

          <v-col cols="3" class="d-flex justify-center">
            <ShareNetwork
              @open="issheet_share = false"
              network="Email"
              :url="taxi_c_set.company_site"
              :title="pro_name"
              :description="
                'من ' +
                pro_name +
                ' گرفتم و تاکسی این مشخصات رو دارد - ' +
                'نام راننده: ' +
                service_data.driver_name +
                ' - نام خودرو: ' +
                service_data.car_name +
                ' - رنگ خودرو: ' +
                service_data.car_color +
                ' - پلاک خودرو: ' +
                plaque_[0] +
                ' ' +
                plaque_[1] +
                ' ' +
                plaque_[2] +
                ' ' +
                plaque_[3] +
                ' ایران '
              "
            >
              <img style="width: 60px" src="@/assets/images/Email.png" />
            </ShareNetwork>
          </v-col>
        </div>
      </v-sheet>
    </vue-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import { toast } from "vue3-toastify";

export default {
  name: "service_page",
  props: {
    service_data: Array,
  },
  components: {
    VueBottomSheet,
  },
  data() {
    return {
      pro_name: "",
      issheet_share: false,
      loading: false,
      selection: 1,
      time: "",
      UseCredit: "manual",
      plaque_: [],
      bol: false,
      credit: 0,
      snackbar_color: "",
      snackbar: false,
      text: "",
    };
  },
  computed: {
    ...mapGetters(["taxi_c_set"]),
  },
  mounted() {
    let self = this;
    self.pro_name = this.taxi_c_set.app_FnName;
    self.get_credit();
    self.set_plaque();
  },
  methods: {
    get_credit() {
      let self = this;
      this.helperGet_taxi(
        "customer-get-credit",
        "uid=" + this.$store.state.auth_taxi.uid
      ).then(function (r) {
        if (r.data.result == "1") {
          self.credit = r.data.data.credit;
        }
      });
    },
    set_plaque() {
      let plaque_ = this.service_data.plaque.split("|");

      this.plaque_[0] = plaque_[0];
      this.plaque_[1] = plaque_[1];
      this.plaque_[2] = plaque_[2];
      this.plaque_[3] = plaque_[3];
      this.bol = !this.bol;
    },

    close_modal() {
      this.$emit("close");
    },
    creadit_pay() {
      this.$emit("creadit_pay");
    },
    reserve() {
      this.loading = true;

      setTimeout(() => (this.loading = false), 2000);
    },

    credit_method(method) {
      let self = this;
      self.UseCredit = method;
      this.helperGet_taxi(
        "customer-change-payment-method",
        "uid=" +
          this.$store.state.auth_taxi.uid +
          "&service_id=" +
          this.service_data.service_id +
          "&payment_method=" +
          method
      ).then(function (r) {
        // console.log('sds',r)
        if (r.data.result == "1") {
          self.UseCredit = method;
        } else {
          self.UseCredit = "manual";
          toast(r.data.msg, {
            autoClose: 3000,
            position: "top-right",
            type: "info",
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.vs-switch--circle {
  height: 25px !important;
}

.vs-switch-success {
  width: 80px !important;
  margin: auto;
  height: 30px;
  background: rgb(218, 83, 83);
}

.vs-switch--text.active-text span {
  padding-left: 7px !important;
}

.vs-switch-success.vs-switch-active {
  background: #176af3;
}

.service {
  padding-top: 16px;

  .serviceContent {
    .contentHeader {
      width: calc(100% - 32px);
      margin-left: auto;
      margin-right: auto;
      padding: 16px;
      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
        0 2px 4px -2px rgb(0 0 0 / 0.1);
      border-radius: 10px;
      background: #fff;
      direction: rtl;
      margin-bottom: 18px;
      border: 1px solid #ededed;

      .headerThumb {
        display: flex;
        align-items: center;
        gap: 12px;
        position: relative;
        color: #000;

        &.costThumb {
          padding-bottom: 12px;
          border-bottom: 1px solid #ededed;
        }

        &.creditThumb {
          padding-top: 12px;

          .thumbIcon {
            svg {
              fill: #fff;
            }
          }
        }

        .thumbIcon {
          color: #fff;
          width: 32px;
          height: 32px;
          background: #0851a0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);

          svg {
            width: 20px;
            height: 20px;
          }
        }

        .thumbContent {
          display: flex;
          align-items: center;
          gap: 4px;

          .contentTitle {
            font-family: "iranyekanB", sans-serif;
            font-size: 0.95rem;
            margin-bottom: 4px;
          }

          .contentValue {
            font-family: "iranyekan", sans-serif;
            font-size: 0.95rem;
            color: #454545;
            display: flex;
            align-items: center;
            gap: 4px;

            span {
              &:last-child {
                font-size: 0.7rem;
                margin-top: 4px;
              }
            }
          }
        }

        .thumbBtn {
          position: absolute;
          left: 8px;
          top: 12px;
          z-index: 1;

          .addCreditBtn {
            width: 32px;
            height: 32px;
            cursor: pointer;
            color: #0851a0;

            svg {
              width: 32px;
              height: 32px;
              stroke-width: 2.5;
            }
          }
        }
      }
    }

    .PeymentMethods {
      &.payemntMethodTitle {
        color: #000;
        margin-top: 0;
        font-size: 1.1rem;
        width: 86%;
        margin-left: auto;
        margin-right: auto;
        text-align: right;
        padding-right: 24px;
        position: relative;

        &::before {
          content: "";
          display: block;
          width: 14px;
          height: 3px;
          background: #000;
          position: absolute;
          right: 0;
          top: 20px;
        }
      }
    }

    .paymentMethodsoptions {
      width: calc(100% - 32px);
      margin-left: auto;
      margin-right: auto;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;

      .optionThumb {
        direction: rtl;
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
        font-family: "iranyekanB", sans-serif;
        font-size: 0.85rem;
        border-radius: 10px;
        background: #f7f7f7;
        border: 1px solid #dedede;
        color: #000;
        transition: all 0.15s;

        &.walletThumb {
          svg {
            fill: #000;
          }
        }

        &:active {
          transform: scale(0.95);
        }

        &.selected {
          border: 1px solid #0851a0;
          background: #0851a0;
          color: #fff;

          &.walletThumb {
            svg {
              fill: #fff;
            }
          }
        }

        svg {
          width: 20px;
          height: 20px;
          transition: all 0.15s;
        }
      }
    }

    .destionationThumbWrapper {
      width: 86%;
      margin-left: auto;
      margin-right: auto;
      margin-top: 24px;
    }

    .destionationThumb {
      width: 100%;
      display: flex;
      align-items: flex-start;
      gap: 12px;
      direction: rtl;
      border-bottom: 1px solid #dedede;
      padding-left: 6px;
      padding-right: 6px;

      &.beforeLastmarker {
        border-bottom: none !important;
      }

      &.Lastmarker {
        border-bottom: none !important;
      }

      .thumbIcon {
        width: 20px;
        height: 20px;
        position: relative;
        background: #0851a0;
        flex-shrink: 0;
        margin-top: 14px;

        &.circle {
          border-radius: 50%;

          &::before {
            border-radius: 50%;
          }
        }

        &.square {
          border-radius: 4px;

          &::before {
            border-radius: 1px;
          }
        }

        &::before {
          content: "";
          display: block;
          width: 8px;
          height: 8px;
          background: #fff;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .thumbInfo {
        flex-grow: 1;
        display: flex;
        align-items: flex-start;
        gap: 4px;
        padding: 10px 0;

        .thumbTitle {
          font-family: "iranyekanB", sans-serif;
          font-size: 0.95rem;
          color: #000;
        }

        .thumbValue {
          font-size: 0.8rem;
          color: #555;
        }
      }
    }

    .travelShareBtn {
      direction: rtl;
      width: calc(100% - 32px);
      margin-left: auto;
      margin-right: auto;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      background: #0851a0;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
      font-family: "iranyekanB", sans-serif;
      font-size: 0.9rem;
      color: #fff;
      border-radius: 10px;
      margin-top: 16px;

      svg {
        width: 24px;
        height: 24px;
        fill: #fff;
      }
    }
  }
}
</style>
